<template>
  <div class="v-atlas-ikm-main">
    <TabsGroup class="x-auto-expand">
      <!--#region Data table tab-->
      <Tab label="Datentabelle" tab-key="list">
        <div class="c-padded">
          <template v-if="props.mapModule.reactiveData.regions">
            <table class="ikm-regions-table">
              <thead>
                <tr>
                  <th>Metropolregion</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="feature in sortedRegions" :key="feature.properties?.id" style="cursor: pointer"
                  @click="props.mapModule.selectRegion(feature.properties?._id ?? null, feature.properties?.name ?? null)">
                  <td>{{ feature.properties?.name }}</td>
                  <td>
                    {{ feature.properties?.[props.mapModule.reactiveData.requestSettings.attrName]
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </Tab>
      <!--#endregion Data table tab-->

      <!--#region Options tab-->
      <Tab label="Optionen" tab-key="settings">
        <div class="c-padded">
          <!-- Remains empty for now -->
          Hier ist erst mal nichts
        </div>
      </Tab>
      <!--#endregion Options tab-->
    </TabsGroup>

    <LoadingIndicatorOverlay v-if="isLoadingDelayed" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { LoadingIndicatorOverlay, ViewStackController, Tab, TabsGroup, useDelayedBoolean } from "gertrud";
import { IkmMapModule } from "./IkmMapModule";


const props = withDefaults(defineProps<{
  mapModule: IkmMapModule
  viewStackController: ViewStackController
}>(), {
});

const isLoading = computed(() => props.mapModule.reactiveData.isLoading)
const isLoadingDelayed = useDelayedBoolean(isLoading, 250, 0);

const sortedRegions = computed(() => {
  const features = props.mapModule.reactiveData.regions?.features ?? []
  return [...features].sort((a, b) =>
    (a.properties?.name ?? "").localeCompare(b.properties?.name ?? "", "de")
  )
})




</script>
